import { render } from "./ButtonGroup.vue?vue&type=template&id=23f09196"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script